<template>
    <div class="search-middle container">
        <!-- * 标题 -->
        <h1 class="title-2 font-bold color-1">{{ $t("MousePhenoPredict") }}</h1>
        <h2 class="title-5 font-bold color-1">{{ $t("Placeholder.PleaseInputTypeInterest", { type: "Gene" }) }}</h2>

        <!-- * 搜索框 -->
        <ToolSearch size="large" v-model="keyword" :placeholder="$t('Placeholder.SearchGeneOrID', 2)" @search="methods.search" />

        <!-- * 描述信息 -->
        <h3 class="search-introduce font-normal">{{ $t("MousePhenoPredictIntroduction") }}</h3>

        <!-- * 搜索窗口 -->
        <search-gene-modal ref="modal" trigger="none" :selector="[{ key: 'taxonomy_id', value: '10090' }]" @change="methods.change" />
    </div>
</template>

<script lang="ts" setup>
//* 公共组件
import { SearchGeneModal } from "@/components/windows";
import { ToolSearch } from "@/components/controls";
//* 组件属性
import { useComposable } from "./src/composable";

//* 组合函数?
const { refs, methods } = useComposable();
const { modal, keyword } = refs;
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
